import React from 'react';
import PropTypes from 'prop-types';

const ProjectGallery = ({ projects, theme }) => {
  return (
    <div className="projects-container" style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '20px',
      justifyContent: 'center',
      marginTop: '20px'
    }}>
      {projects.map((project) => (
        <a 
          key={project.id}
          href={project.url}
          target="_blank"
          rel="noopener noreferrer"
          className="project-link"
          style={{
            flex: '0 1 calc(50% - 20px)', //50% width with gap
            minWidth: '300px',
            textDecoration: 'none',
            color: 'inherit'
          }}
        >
          <div 
            className="project-item"
            style={{
              border: `2px none`,
              borderRadius: '8px',
              padding: '10px',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              height: '100%'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <img 
              src={project.src} 
              alt={project.alt}
              className="project-image"
              style={{
                width: '100%',
                height: '200px',
                objectFit: 'cover',
                borderRadius: '4px'
              }}
            />
            <h4 style={{ 
              margin: '10px 0 5px',
              textAlign: 'center',
              fontSize: 'var(--font-size-normal)'
            }}>
              {project.title}
            </h4>
          </div>
        </a>
      ))}
    </div>
  );
};

ProjectGallery.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    alt: PropTypes.string
  })).isRequired,
  theme: PropTypes.oneOf(['light', 'dark']).isRequired
};

export default ProjectGallery;